var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plans-list"},_vm._l((_vm.items),function(item){return _c('div',{key:'plan_' + item.id,staticClass:"plan-item"},[_c('router-link',{attrs:{"to":item.url}},[_c('span',[_vm._v(_vm._s(item.name))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }